(function (Drupal, once) {

  Drupal.behaviors.bendrejatHeader = {

    attach(context) {

      once('bendrejat-header', 'body', context).forEach((body) => {

        const header = body.querySelector('.site-header');
        const toggle = body.querySelector('.menu-toggle');
        const navigation = body.querySelector('.site-navigation');

        /*
         * Sticky header.
         */
        let lastScrollY = window.scrollY;

        window.addEventListener('scroll', () => {

          const currentScrollY = window.scrollY;

          if (currentScrollY > 50) {

            if (currentScrollY > lastScrollY) {
              body.classList.add('is-scrolling-down');
            } else {
              body.classList.remove('is-scrolling-down');
            }

            body.classList.add('is-scrolled');

          } else if (currentScrollY === 0) {

            body.classList.remove('is-scrolled');
            body.classList.remove('is-scrolling-down');

          }

          lastScrollY = currentScrollY;

        });

        /*
         * Mobile navigation.
         */
        if (!header || !toggle || !navigation) {
          return;
        }

        toggle.addEventListener('click', () => {

          const isOpen = navigation.classList.toggle('is-open');

          toggle.setAttribute(
            'aria-expanded',
            isOpen ? 'true' : 'false'
          );

        });

        /*
         * Close mobile navigation after clicking a link.
         */
        navigation.querySelectorAll('a').forEach((link) => {

          link.addEventListener('click', () => {

            navigation.classList.remove('is-open');

            toggle.setAttribute(
              'aria-expanded',
              'false'
            );

          });

        });

        /*
         * Reset mobile navigation when returning to desktop.
         */
        window.addEventListener('resize', () => {

          if (window.innerWidth >= 1024) {

            navigation.classList.remove('is-open');

            toggle.setAttribute(
              'aria-expanded',
              'false'
            );

          }

        });

      });

    }

  };

})(Drupal, once);